import { Moon, Sun, Monitor } from 'lucide-react';
import { Button } from '@/client/components/ui/button';
import { useTheme } from '@/client/components/theme-provider';

const CYCLE: Array<'system' | 'light' | 'dark'> = ['system', 'light', 'dark'];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const next = CYCLE[(CYCLE.indexOf(theme) + 1) % CYCLE.length];

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(next)}
      className="w-9 h-9"
      title={`Theme: ${theme}`}
    >
      {theme === 'system' && <Monitor className="h-[1.2rem] w-[1.2rem]" />}
      {theme === 'light' && <Sun className="h-[1.2rem] w-[1.2rem]" />}
      {theme === 'dark' && <Moon className="h-[1.2rem] w-[1.2rem]" />}
      <span className="sr-only">Toggle theme ({theme})</span>
    </Button>
  );
}
